import { dataFetcher } from 'core/services/requestHandler';   

const getDynamicPricingInfo = async (data = {}, config = {}) => {
  return dataFetcher('operations/dynamicPricingInfo', data, {...config});
};

const getDynamicPricingConfig = async (data = {}, config = {}) => {
  return dataFetcher('operations/dynamicPricingConfig', data, {...config});
};

const renewDynamicPricing = async (data = {}, config = {}) => {
  return dataFetcher('operations/renewDynamicPricing', data, {...config});
};

const saveDynamicPrice = async (data = {}, config = {}) => {
  return dataFetcher('operations/saveDynamicPrice', data, {...config});
};

const subscribeToDynamicPricing = async (data = {}, config = {}) => {
  return dataFetcher('operations/subscribeToDynamicPricing', data, {...config});
};
const unsubscribeFromDynamicPricing = async (data = {}, config = {}) => {
  return dataFetcher('operations/unsubscribeFromDynamicPricing', data, {...config});
};

export {getDynamicPricingInfo, getDynamicPricingConfig, renewDynamicPricing, saveDynamicPrice, subscribeToDynamicPricing, unsubscribeFromDynamicPricing}
